import {
  TEMPLATE_FILE_NAME,
  TEMPLATE_HEADERS,
} from 'src/app/BulkInvite/bulkInvite.constants'

// UTF-8 byte order mark — prepended so Excel opens the export without mangling
// accented names. Kept as an escape (not a literal) to satisfy lint.
const BOM = String.fromCharCode(0xfeff)

/** RFC-4180 quoting: wrap fields containing quotes/commas/newlines. */
function toCsv(rows: string[][]): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          const value = cell ?? ''
          if (/[",\n\r]/.test(value)) return `"${value.replace(/"/g, '""')}"`
          return value
        })
        .join(','),
    )
    .join('\r\n')
}

/** Trigger a browser download of the given rows as a UTF-8 CSV (with BOM). */
export function downloadCsv(fileName: string, rows: string[][]): void {
  const blob = new Blob([BOM + toCsv(rows)], {
    type: 'text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

export function downloadTemplate(): void {
  downloadCsv(TEMPLATE_FILE_NAME, [TEMPLATE_HEADERS])
}
